
import { defineComponent } from 'vue';
import Markdown from '../Markdown.vue';
import IconAi from '../Icon/IconAi.vue';
import IconUser from '../Icon/IconUser.vue';

const __default__ = defineComponent({
  components: {
    IconUser,
    IconAi,
    Markdown,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    aiName: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
  },
  computed: {
    chatResponseClasses(): Array<string> {
      return [
        'ai-chat-response',
        `ai-chat-${this.message.role}-response`,
      ];
    },
    chatAuthorName(): string {
      return this.message.role === 'user' ? 'You' : 'AI';
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "a655efa2": (_ctx.aiColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__